export const LIB_VERSION = 'dev';
